import SectionProgress from '../api/sectionProgress';
import { applicationUpdate } from './applicationActions';

export const updateSectionProgress = applicationUpdate(SectionProgress);
